var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.49 8.32771C22.3207 7.57949 23.6583 8.4321 23.2703 9.53181L20.9988 15.9664H23.3406C24.3236 15.9664 24.8221 17.1495 24.1355 17.8531L14.5291 27.6988C13.7018 28.5466 12.2986 27.6836 12.6824 26.5631L14.7449 20.5465H12.6384C11.6675 20.5463 11.1637 19.3884 11.8259 18.6783L21.4109 8.40486L21.49 8.32771ZM13.9168 18.8804H15.5222C16.2841 18.8807 16.82 19.6313 16.573 20.3521L15.0584 24.7681L22.0222 17.6324H20.2136C19.4473 17.6323 18.9116 16.8746 19.1668 16.1519L20.8133 11.4879L13.9168 18.8804Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energyIcon.1ec992a01833c422b91f5bb07557e283.svg";
export { ForwardRef as ReactComponent };